<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Task Upload Mapping</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="p-3">

  <ng-container>
    <div class="alert alert-info mb-3" role="alert">
        Map the columns below to its corresponding fields in the
        <b>sample data</b> table below. If you map more than one column to
        the same field, the data will be concatenated e.g. first name and
        last name columns will be combined into one field called full name
        if you select full name for both columns.
    </div>

    <div class="table-responsive">
      <table class="table table-hover">
        <thead class="thead-light">
          <tr>
            <th scope="col" *ngFor="let field of fields">
              {{ field }}
            </th>
          </tr>
          <tr>
            <th scope="col" *ngFor="let field of fields; let i = index">
              <mat-form-field class="full-width my-2" appearance="outline" subscriptSizing="dynamic">
                <mat-label>Map Field</mat-label>
                <mat-select placeholder="Map Field" [(ngModel)]="action[field]" name="header_{{ i }}" (selectionChange)="onSelectionChange($event, i)">
                  <mat-option value="-1">-- Ignore --</mat-option>
                  <mat-option *ngFor="let f of mapped_fields" [value]="f.value">{{ f.content }}</mat-option>
                </mat-select>
                <mat-hint style="color: red" *ngIf="hasDupliValue() &&
                  getDupliValues(getValueArray(action)).includes(getValue(i))">Duplicate fields selected.</mat-hint>
              </mat-form-field>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let row of data.actionsData.slice(0, 5)">
            <td *ngFor="let field of fields">
              {{row[field]}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>

</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex justify-content-end px-2 py-1">
  <button
    type="button"
    mat-raised-button
    class="my-2 ml-1 mr-2"
    color="primary"
    [disabled]="hasDupliValue()"
    (click)="onSaveAndClose()">
    <mat-icon>save</mat-icon> Save
  </button>
</mat-dialog-actions>
